const ProductEdit = {
  'pages_product_ProductEdit.1': '수정',
  'pages_product_ProductEdit.2': '담당자 변경',
  'pages_product_ProductEdit.3': '* 모든 첨부 파일은 최대 50MB까지 업로드 가능하며,PDF, 이미지(gif,jpg,jepg,png), MS 오피스 파일(xls,xlsx,doc,docx,ppt,pptx) 파일을 지원합니다.',
  'pages_product_ProductEdit.file.1': '첨부 파일(브로슈어)',
  'pages_product_ProductEdit.file.2': '첨부 파일(intro)',
  'pages_product_ProductEdit.file.3': '첨부 파일(etc)',
  'pages_product_ProductEdit.message.1': '상품이 수정되었습니다.',
  'pages_product_ProductEdit.error': '에러가 발생했습니다.'
}

export default ProductEdit



// WEBPACK FOOTER //
// ./src/lang/product/ProductEdit.kr.js